import OspreyApiHelper from './helper'

export default class OspreySilos {

    static get(path, params) {
        return OspreyApiHelper.genericGet(path, params)
    }

    static put(path, params) {
        return OspreyApiHelper.genericPut(path, params.silo)
    }
}



// WEBPACK FOOTER //
// src/services/osprey-api/api-silos.js